export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["Unknown"] = 0] = "Unknown";
    PaymentMethod[PaymentMethod["AutomaticPayment"] = 1] = "AutomaticPayment";
    PaymentMethod[PaymentMethod["PaymentRequest"] = 2] = "PaymentRequest";
    PaymentMethod[PaymentMethod["PaymentPlan"] = 3] = "PaymentPlan";
    PaymentMethod[PaymentMethod["PaymentDenied"] = 4] = "PaymentDenied";
})(PaymentMethod || (PaymentMethod = {}));
